import { render, staticRenderFns } from "./InjectionRateFilter.vue?vue&type=template&id=3d8a0e00"
import script from "./InjectionRateFilter.vue?vue&type=script&lang=ts"
export * from "./InjectionRateFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports